module.exports = __webpack_public_path__ + "img/unelmakone-karta-en-mobile.bae6d98e.jpg";